<template>
  <div class="LoginPage">
    <PopupBackground v-if="!isAndroidContext" class="background"/>
    <MainPageHeader class="main-page-header"/>
    <div class="content">
      <PopupBackground v-if="!isAndroidContext"/>
      <form class="popup" @submit.prevent="">
        <h1 class="font-size-big">Zaloguj się</h1>
        <div class="fields">
          <div v-if="loadingError" class="loginError">
            <div>
              <img
                  src="@/assets/images/errorIcon.svg"
                  alt=""
                  :class="{ bounce: animate }"
              />
              <p class="font-size-middle">Wprowadź poprawny login oraz hasło.</p>
            </div>
          </div>
          <DefaultInputField
              v-model="email"
              placeholder="E-mail zespołu"
              type="email"
          />
          <DefaultInputField
              v-model="password"
              placeholder="Hasło"
              type="password"
          />
          <div class="field-actions">
            <div class="checkbox-field font-size-small">
              <Checkbox v-model="rememberMe" :checked="rememberMe" @click="() => rememberMe = !rememberMe"/>
              Zapamiętaj mnie
            </div>
            <div class="switch-mode-recovery font-size-small" @click="$router.replace({name:'accountRecovery'})">
              Nie pamiętasz hasła?
            </div>
          </div>
        </div>
        <LoadingButton
            type="submit"
            @click="doLogin"
            :isLoading="isLoading"
            class="log-in-button"
        >Zaloguj się
        </LoadingButton>
        <div class="sign-up">
          <p class="font-size-middle">Nie masz konta?</p>
          <span
              class="switch-mode-button font-size-middle"
              @click="$router.replace({ name: 'signUpPage' })"
          >
            ZAREJESTRUJ SIĘ
          </span>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MainPageHeader from "../components/MainPageHeader.vue";
import Checkbox from "../components/input/Checkbox.vue";
import DefaultInputField from "../components/input/DefaultInputField.vue";
import PopupBackground from "../components/PopupBackground.vue";
import {getAuthService} from "../services/authService";
import LoadingButton from "../components/input/LoadingButton.vue";
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'LoginPage',
  components: {
    MainPageHeader,
    DefaultInputField,
    PopupBackground,
    LoadingButton,
    Checkbox,
  },
  data () {
    return {
      loadingError: false,
      animate: false,
      isLoading: false,
      continueUrl: this.$route.query.continueUrl || undefined,
      email: '',
      password: '',
      productDetails: {},
      rememberMe: true,
    }
  },
  props: {
    fromPage: String
  },
  methods: {
    async doLogin () {
      this.animate = false
      this.isLoading = true
      this.productDetails = (this.$route.params.productDetails)
      const loggedIn = await getAuthService().logIn(this.email, this.password)
      if (!loggedIn) {
        this.loadingError = true
        this.isLoading = false
        this.animate = true
      } else if (loggedIn) {
        if (this.fromPage) {
          this.$router.push({
            path: this.fromPage,
          }).catch((e) => {
            if (!isNavigationFailure(e, NavigationFailureType.redirected) && isNavigationFailure(e)) {
              Promise.reject(e)
            }
          })
        } else if (this.productDetails != null) {
          this.$router.push({
            name: 'summaryPage',
          })
        } else {
          this.$router.go(-1)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.LoginPage {
  position: relative;
  min-height: 100vh;
}

.background {
  position: fixed;
  z-index: 1;
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;

  .popup {
    box-sizing: content-box;
    padding: 50px 50px;
    width: 100%;
    max-width: 550px;
    border: 2px solid $primary;
    position: relative;
    z-index: 50;

    h1 {
      margin: 0;
      margin-bottom: 30px;
      padding: 20px;
      color: $primary;
      text-align: center;
      border-bottom: 2px solid $primary;
    }

    .loginError {
      font-weight: normal;
      display: flex;
      width: 100%;
      justify-content: center;
      color: $red;

      div {
        display: flex;
      }

      p {
        margin-left: 15px;
      }

      img {
        max-width: 1.5rem;
        fill: $red;
      }

      .bounce {
        animation-name: bounce;
        animation-timing-function: 1s linear;
        animation-duration: 1.25s;
        animation-iteration-count: 2;
        transition: all 0.25s;
      }

      @keyframes bounce {
        0% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(-3px);
        }
        100% {
          transform: translateY(0);
        }
      }
    }

    .fields {
      margin: 0 auto;
      max-width: 350px;

      .or {
        text-align: center;
      }

      .auth-button {
        display: block;
        width: 100%;
        margin: 20px 0;
      }

      .field-actions {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .checkbox-field {
          display: flex;
          align-items: center;
          color: #ddd;

          span {
            margin-right: 0.5em;
          }
        }

        .switch-mode-recovery {
          text-decoration: none;
          color: #ddd;
          cursor: pointer;
        }
      }
    }

    .log-in-button {
      display: flex;
      justify-content: center;
      margin: 0;
      margin-top: 30px;
    }

    .sign-up {
      display: flex;
      justify-content: center;
      margin-top: 70px;

      p {
        margin: 0;
        margin-right: 20px;
        color: #999;
      }

      .switch-mode-recovery {
        text-decoration: none;
        color: #ddd;
        cursor: pointer;
      }

      .switch-mode-button {
        cursor: pointer;
      }
    }
  }
}

// Mobile style
@media (max-width: $phone-max-width) {
  .main-page-header {
    display: none;
  }

  .content {
    position: static;
    margin: 50px 10px;

    .popup {
      padding: 30px 20px;
    }
  }
}
</style>